<template>
  <div class="form-container details-confirm">
    <div class="body__top">
      <h1 class="body__title">
        <slot name="title"></slot>
      </h1>
      <!-- eslint-disable -->
      <p class="body__text">
        <slot name="description"></slot>
      </p>
    </div>
    <!-- eslint-enable -->
    <div class="form">
      <ConfirmForm
        v-if="formName === 'confirm'"
      />
      <PersonaliseForm
        v-if="formName === 'personalise'"
      />
      <CanberraForm
        v-if="formName === 'canberra'"
      />
    </div>
  </div>
</template>

<script>
import ConfirmForm from '@/components/ConfirmForm.vue';
import PersonaliseForm from '@/components/PersonaliseForm.vue';
import CanberraForm from '@/components/CanberraForm.vue';

export default {
  name: 'MembershipFormWrap',
  components: {
    ConfirmForm,
    PersonaliseForm,
    CanberraForm,
  },
  props: [
    'formName',
  ],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "@/assets/scss/settings.scss";

$form-container-width: 470px + $spacing-double;
$form-padding: $spacing;
$form-padding-double: $spacing-double;
$form-gap: $spacing;

$form-text-color: $body-text-alt;

$field-label-dark: $charcoal-dark;
$field-text-colour: $grey-light;

$field-gap: $spacing;
$field-gap-small: $spacing-half;
$field-date-field: $grey-lighter;

$field-font-size: $body-font-size-compressed;
$field-font-size-small: $body-font-size-small;
$field-text-font-size: $body-font-size-xsmall;

.body__top {
  margin-bottom: $form-padding;
  text-align: center;

  @include medium-up {
    margin-bottom: $form-padding-double;
  }
}

.body__text {
  line-height: 20px;
  color: $form-text-color;

  & + .body__text {
    margin-top: $spacing;
  }
}

.form-container {
  width: 100%;
  max-width: $form-container-width;
  padding: $form-gap $form-padding;
  margin: 0 auto;

  @include medium-up {
    padding: $form-gap $form-padding $form-padding-double;
  }
}

.field-group {
  position: relative;
  margin-bottom: $field-gap-small;
  font-size: $field-font-size;
  line-height: 1.5em;
}

.field-group--padded {
  margin-top: $field-gap;
}

.field-group--center {
  text-align: center;
}

.field-group--right {
  text-align: right;
}

.field-submit {
  margin-top: $spacing-double;

  @include small-up {
    margin-top: $spacing-quad;
  }
}

.field__text {
  font-size: $field-text-font-size;
}
</style>
